import { lazy } from "react";
import {
    Navigate,
} from "react-router-dom";

const GroupListComponent = lazy(() => import("../../../../../components/groups/components/list/page"));
const GroupAddComponent = lazy(() => import("../../../../../components/groups/components/add/page"));

export const groupRoute = [
    {
        path: 'list',
        element: <GroupListComponent />
    },
    {
        path: 'add',
        element: <GroupAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/models/groups/add" />
    },
    {
        path: 'edit/:id',
        element: <GroupAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/models/groups/list" />
    },
];